import axiosHelper from '../../../helpers/axiosHelper';

import React from 'react';
import { useForm, SubmitHandler } from 'react-hook-form';
import { User } from '../../../global';
import FormField from '../../Forms/FormField';
import { useBanner } from '../../../context/BannerContext';
interface ChangePasswordFormData {
  oldPassword: string;
  newPassword: string;
  confirmNewPassword: string;
}

const UpdatePassword: React.FC<{ user: User }> = ({ user }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm<ChangePasswordFormData>();
  const { createAndAddBannerMessage } = useBanner();
  const onSubmit: SubmitHandler<ChangePasswordFormData> = async (data) => {
    try {
      const response = await axiosHelper.changePassword(data.oldPassword, data.newPassword);
      console.log(response);
      createAndAddBannerMessage('Password changed successfully!', 'success');
    } catch (error) {
      console.error('Error changing password', error);
      createAndAddBannerMessage('Failed to change password', 'error');
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <input type="hidden" value={user.username} autoComplete="username" />

      <div className="px-5 mt-7">
        <FormField name="oldPassword" label="Old password" error={errors.oldPassword} required>
          <input type="password" autoComplete="current-password" {...register('oldPassword', { required: 'Old password is required' })} />
        </FormField>

        <FormField name="newPassword" label="New password" error={errors.newPassword} required>
          <input
            type="password"
            autoComplete="new-password"
            {...register('newPassword', {
              required: 'New password is required',
              minLength: { value: 8, message: 'Password must be at least 8 characters' },
            })}
          />
        </FormField>
        <FormField name="confirmNewPassword" label="Repeat new password" error={errors.confirmNewPassword} required>
          <input
            type="password"
            autoComplete="new-password"
            {...register('confirmNewPassword', {
              required: 'Please confirm your new password',
              validate: (value) => value === watch('newPassword') || 'Passwords do not match',
            })}
          />
        </FormField>
        <div className="row  d-flex justify-content-center align-items-center mb-7 mt-4">
          <div className="row justify-content-center">
            <button className="col-12 col-md-3 my-5 btn-success rounded 3 button">update password</button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default UpdatePassword;
